(function () {
  'use strict';

  var config = { giftVariantId: 52277867184461, thresholdCents: 5000, checkDelayMs: 650, reloadDelayMs: 450 };
  var state = { syncing: false, pending: false, lastRun: 0, reloading: false };

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function endpoint(path) { var base = root(); if (base.charAt(base.length - 1) !== '/') base += '/'; return base + (path.charAt(0) === '/' ? path.slice(1) : path); }
  function asNumber(value) { var number = Number(value); return Number.isFinite(number) ? number : 0; }
  function sameVariant(line) { return String(line.variant_id || line.id || '') === String(config.giftVariantId); }
  function isManagedGift(line) { return sameVariant(line) && line.properties && line.properties._sv_free_gift === 'melatonina_gummies'; }
  function lineValue(line) { return asNumber(line.final_line_price != null ? line.final_line_price : (line.line_price != null ? line.line_price : line.original_line_price)); }
  function subtotalWithoutManagedGift(cart) { return (cart.items || []).reduce(function (sum, line) { return isManagedGift(line) ? sum : sum + lineValue(line); }, 0); }

  function fetchCart() {
    return fetch(endpoint('/cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(endpoint('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/change.js ' + response.status);
      return response.json();
    });
  }

  function addGift() {
    return fetch(endpoint('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: config.giftVariantId, quantity: 1, properties: { _sv_free_gift: 'melatonina_gummies' } }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add.js ' + response.status);
      return response.json();
    });
  }

  function reloadAfterCartMutation(reason) {
    if (state.reloading) return;
    state.reloading = true;
    try { sessionStorage.setItem('sv_free_gift_last_action', reason || 'sync'); } catch (error) {}
    setTimeout(function () { window.location.reload(); }, config.reloadDelayMs);
  }

  function normalizeGiftLines(giftLines) {
    var tasks = [];
    giftLines.forEach(function (line, index) {
      if (index === 0 && line.quantity === 1) return;
      tasks.push(changeLine(line.key, index === 0 ? 1 : 0));
    });
    return Promise.all(tasks);
  }

  function syncGift(reason) {
    if (state.reloading) return Promise.resolve(false);
    if (state.syncing) { state.pending = true; return Promise.resolve(false); }
    var now = Date.now();
    if (reason !== 'cart-network' && now - state.lastRun < 250) { state.pending = true; return Promise.resolve(false); }
    state.syncing = true; state.pending = false; state.lastRun = now;

    return fetchCart().then(function (cart) {
      var giftLines = (cart.items || []).filter(isManagedGift);
      var eligible = subtotalWithoutManagedGift(cart) >= config.thresholdCents;
      if (eligible && giftLines.length === 0) return addGift().then(function () { return 'added'; });
      if (eligible && giftLines.length > 0) return normalizeGiftLines(giftLines).then(function (changes) { return changes.length ? 'normalized' : false; });
      if (!eligible && giftLines.length > 0) return Promise.all(giftLines.map(function (line) { return changeLine(line.key, 0); })).then(function () { return 'removed'; });
      return false;
    }).then(function (result) {
      if (result === 'added' || result === 'removed' || result === 'normalized') reloadAfterCartMutation(result);
      return result;
    }).catch(function (error) {
      console.warn('[Sevens free gift checkout-safe] No se pudo sincronizar el regalo:', error && error.message ? error.message : error);
      return false;
    }).finally(function () {
      state.syncing = false;
      if (state.pending && !state.reloading) setTimeout(function () { syncGift('pending'); }, 180);
    });
  }

  function schedule(reason) { setTimeout(function () { syncGift(reason); }, config.checkDelayMs); setTimeout(function () { syncGift(reason); }, 1600); }

  document.addEventListener('click', function () { schedule('click'); }, true);
  document.addEventListener('submit', function () { schedule('submit'); }, true);
  ['change', 'input', 'cart:update', 'cart:updated', 'cart:refresh', 'quantity-selector:update', 'variant:add'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(name); }, true);
  });

  window.addEventListener('pageshow', function () { syncGift('pageshow'); });
  window.addEventListener('focus', function () { schedule('focus'); });
  document.addEventListener('DOMContentLoaded', function () { syncGift('ready'); });

  if (typeof window.fetch === 'function' && !window.__svFreeGiftReloadFetchPatchedManualSafe) {
    var originalFetch = window.fetch;
    window.__svFreeGiftReloadFetchPatchedManualSafe = true;
    window.fetch = function () {
      var args = arguments;
      var url = String(args[0] && args[0].url ? args[0].url : args[0] || '');
      return originalFetch.apply(this, args).then(function (response) {
        if (/\/cart\/(add|change|update|clear)\.js|\/cart\/change|\/cart\/update/.test(url)) schedule('cart-network');
        return response;
      });
    };
  }

  if (window.XMLHttpRequest && !window.__svFreeGiftReloadXhrPatchedManualSafe) {
    var originalOpen = XMLHttpRequest.prototype.open;
    window.__svFreeGiftReloadXhrPatchedManualSafe = true;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('loadend', function () {
        if (/\/cart\/(add|change|update|clear)\.js|\/cart\/change|\/cart\/update/.test(String(url || ''))) schedule('cart-xhr');
      });
      return originalOpen.apply(this, arguments);
    };
  }

  setInterval(function () { syncGift('interval'); }, 3000);
  if (document.readyState !== 'loading') syncGift('loaded');
})();